import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import { HeroSection } from '../components/sections/HeroSection';
import { TrustStrip } from '../components/sections/TrustStrip';
import { ServicesSection } from '../components/sections/ServicesSection';
import { WhyUsSection } from '../components/sections/WhyUsSection';
import { AfricanPresenceSection } from '../components/sections/AfricanPresenceSection';
import { WorkPreviewSection } from '../components/sections/WorkPreviewSection';
import { ProcessSection } from '../components/sections/ProcessSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { BlogPreviewSection } from '../components/sections/BlogPreviewSection';
import { CTASection } from '../components/sections/CTASection';
export function HomePage() {
  usePageMeta({
    title: 'Creative Digital Agency in Africa',
    description: 'Belo Digital helps businesses across Africa and the world go digital with confidence. Web design, branding, marketing, and corporate media solutions.'
  });
  return <main data-id="element-792">
      <HeroSection data-id="element-793" />
      <ServicesSection data-id="element-794" />
      <WhyUsSection data-id="element-795" />
      <AfricanPresenceSection data-id="element-796" />
      <WorkPreviewSection data-id="element-797" />
      <ProcessSection data-id="element-798" />
      <TestimonialsSection data-id="element-799" />
      <CTASection data-id="element-800" />
      <BlogPreviewSection data-id="element-801" />
      <TrustStrip data-id="element-802" />
    </main>;
}